import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {ISafetyProfile, SafetyProfile} from 'app/blocks/model/safety-profile.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {VehicleCheckListService} from 'app/blocks/service/api/vehicle-check-list.service';

@Injectable({
    providedIn: 'root'
})
export class VehicleCheckListResource extends AbstractEntityResource<ISafetyProfile> {
    constructor(vehicleCheckListService: VehicleCheckListService, router: Router) {
        super(
            Resource.VEHICLE_CHECKLISTS,
            vehicleCheckListService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.VEHICLE_CHECKLISTS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.VEHICLE_CHECKLISTS),
            (entity?) => new SafetyProfile(entity),
            (entity) => entity.name
        );
    }
}
